export const selectDateOptions = [
    {
        "option": {
            "value": "Cette année",
        }
    },
    {
        "option": {
            "value": "Ce mois-ci",
        }
    },
    {
        "option": {
            "value": "1 année glissante",
        }
    },
    {
        "option": {
            "value": "2 années glissantes",
        }
    },
    {
        "option": {
            "value": "L'année dernière",
        }
    },
    {
        "option": {
            "value": "Il y a deux ans",
        }
    },
    {
        "option": {
            "value": "L'année dernière et la précédente",
        }
    },
];

export const selectDateOptionsNew = [
    {
        name: "Cette année",
        id: '0',
        value: '0'
    },
    {
        name: "Ce mois-ci",
        id: '1',
        value: '1'
    },
    {
        name: "1 année glissante",
        id: '2',
        value: '2'
    },
    {
        name: "2 années glissantes",
        id: '3',
        value: '3'
    },
    {
        name: "L'année dernière",
        id: '4',
        value: '4'
    },
    {
        name: "Il y a deux ans",
        id: '5',
        value: '5'
    },
    {
        name: "L'année dernière et la précédente",
        id: '6',
        value: '6'
    },
];
